module.exports = __webpack_public_path__ + "static/img/2_2_1_3.b8f9cc50.jpg";